<template>
    <component
        :is="$source.orderButton.tag"
        v-bind="attrs"
        class="node-drag oc-table-order-btn btn btn-info btn-sm"
        v-class="classes"
        :title="title"
        v-html="text"
    />
</template>

<script>
export default {
    name: 'oc-column-order-after-content',
    inheritAttrs: false,
    inject: ['$source'],
    computed: {
        text() {
            return this.$source.orderButton.text === undefined ? '&#8597;' : this.$source.orderButton.text
        },
        title() {
            return this.attrs.title || 'Change order'
        },
        attrs() {
            return this.$source.orderButton.attrs || {}
        },
        classes() {
            return this.attrs.class || {}
        }
    }
}
</script>

<style scoped>
.node-drag {
    cursor: move;
}
</style>
